module.exports = __webpack_public_path__ + "img/36.a5f14e18.png";